import React from 'react';

import { openModal, closeModal, doLogout } from 'actions/env';
import { appsignal } from 'config/appsignal';
import { conf } from 'config/env';
import routes from 'config/routes';
import { getStore, getDispatcher } from 'config/store';
import getLexique from 'locales';

import ErrorMessage from 'components/ui/modales/ErrorMessage';
import ErrorNetworkMessage from 'components/ui/modales/ErrorNetworkMessage';

let isOnline = window.navigator.onLine;
export const setNetworkListener = () => {
	window.addEventListener('online',  onNetworkUpdate);
	window.addEventListener('offline', onNetworkUpdate);
	onNetworkUpdate();
}

export const unsetNetworkListener = () => {
	window.removeEventListener('online',  onNetworkUpdate);
	window.removeEventListener('offline', onNetworkUpdate);
}

const onNetworkUpdate = () => {
	const now = window.navigator.onLine;

	if ((isOnline && !now) || (!isOnline && !now)) {
		// show modal error
		openModaleDidYouKnow();
	}

	if (!isOnline && now) {
		// Hide modal error
		closeModaleDidYouKnow();
	}

	isOnline = now;
}

let isModaleDidYouKnowOpened = false;

export const openModaleDidYouKnow = () => {
	if (isModaleDidYouKnowOpened) return;
	const lexique = getLexique(getStore().env.locale);
	const dispatch = getDispatcher();
	dispatch(openModal({
		content: <ErrorNetworkMessage
					lexique={lexique.global.errors.offline}
				 />,
		closable: false,
		className: 'modal--error',
	}));
	isModaleDidYouKnowOpened = true;
}

export const closeModaleDidYouKnow = () => {
	if (!isModaleDidYouKnowOpened) return;
	const dispatch = getDispatcher();
	dispatch(closeModal());
	isModaleDidYouKnowOpened = false;
}

export const moveToRoot = () => {
	window.location.href = conf.urls.app
}

export const moveToLogin = () => {
  if (!window.location.href.includes(routes.auth.home)) {
    window.location.href = routes.auth.login;
  }
};

export const errorParser = (error, datas) => {
	broadcastError("Runtime Error", error, {...datas, code: 'RUN' });
}

export const errorCatcher = (error, datas) => {
	const dispatch = getDispatcher();
	const lexique = getLexique(getStore().env.locale);

	const code = error && error.response && error.response.status ? error.response.status : datas.code;

	// Only redirect on 401
	if (code === 401) {
		moveToLogin();
		return;
	}

	const handleLogout = async () => {
		dispatch(closeModal());
		await dispatch(doLogout());
	};

	dispatch(openModal({
		content: <ErrorMessage
			closable={true}
			onAcknowledge={() => dispatch(closeModal())}
			onLogout={code === 403 ? handleLogout : null}
			code={code}
			lexique={lexique.global.errors}
		/>,
		closable: true,
		className: 'modal--error',
		onClose: () => dispatch(closeModal())
	}));

	// Broadcast error to logging service (except for 401 and 403)
	if ([401, 403].indexOf(code) === -1) {
		broadcastError("Api Error", error, {code, ...datas});
	}
}

const broadcastError = (type, error, datas) => {
	console.log(`:-: Broadcast ${type} - ${datas.code} :-:`); //eslint-disable-line no-console

	const { id, firstName, lastName } = getStore().env.user;
	appsignal.sendError(error, (span) => {
	  span.setTags({
		id,
		name: `${firstName} ${lastName}`,
		currentUrl: window.location.href,
		type,
		error,
		datas,
	  });
	});
}
